// @ai-generated 2026-09-28T09:29:39+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import {
    AGENTIC_ORCHESTRATOR_API,
    AI_GATEWAY_API,
    AUDITING_API,
    AUFTRAG_API,
    BILLING_API,
    DOCUMENTS_API,
    EXTERNAL_ERP_PROXY_API,
    MAILING_API,
    MESSAGES_API,
    PERMISSIONS_API,
    SCHEDULING_API,
    STAMMDATEN_API,
} from '@Constants/backendConstants';
import { type HttpActions, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMemo } from 'react';

/** A generated repository, which takes nothing but the http client of its own service. */
export type RepositoryConstructor<T> = new (http: HttpActions) => T;

/**
 * A generated repository wired to the service it belongs to.
 *
 * The instance is not guaranteed to be referentially stable, so a caller should not list it in a
 * dependency array unless it also depends on the base url.
 */
export function useRepository<T>(repository: RepositoryConstructor<T>, baseUrl: string): T {
    const http = useSynqoHttp(baseUrl);

    return useMemo(() => new repository(http), [repository, http]);
}

export const useAgenticOrchestratorRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, AGENTIC_ORCHESTRATOR_API);

export const useAiGatewayRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, AI_GATEWAY_API);

export const useAuditingRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, AUDITING_API);

export const useAuftragRepository = <T>(repository: RepositoryConstructor<T>) => useRepository(repository, AUFTRAG_API);

export const useBillingRepository = <T>(repository: RepositoryConstructor<T>) => useRepository(repository, BILLING_API);

export const useDocumentsRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, DOCUMENTS_API);

export const useExternalErpProxyRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, EXTERNAL_ERP_PROXY_API);

export const useMailingRepository = <T>(repository: RepositoryConstructor<T>) => useRepository(repository, MAILING_API);

export const useMessagesRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, MESSAGES_API);

export const usePermissionsRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, PERMISSIONS_API);

export const useSchedulingRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, SCHEDULING_API);

export const useStammdatenRepository = <T>(repository: RepositoryConstructor<T>) =>
    useRepository(repository, STAMMDATEN_API);
